import React from 'react';
import cn from 'classnames';
import { Menu } from '@headlessui/react'

type Props = {
  caption: string
  className?: string
  onClick?: () => void
  onlyChildren?: boolean
}

/**
 * A dropdown menu item.
 * @param caption The caption of the item.
 * @param className Additional classes for the item
 * @param onClick The function to call when the item is clicked.
 * @param children The children of the item. By default, they are rendered before the caption, and usually include an icon
 * @param onlyChildren If true, the caption is not rendered, only children. It allows to change the whole item.
 * @constructor
 */
export default function DropdownMenuItem({ caption, className, onClick, children, onlyChildren = false }: React.PropsWithChildren<Props>) {
  return (
    <Menu.Item>
      <div onClick={onClick} className={cn('hover:bg-blue-table-hover py-2 px-6 cursor-pointer', className)}>
        {children}
        {!onlyChildren && <span className="truncate">{caption}</span>}
      </div>
    </Menu.Item>
  )
}
